import React from 'react';
import FindOrder from '../../../components/Ecommerce/FindOrder';
import { Link } from 'react-router-dom';

function FIndTikTokOrder() {
    const logo = {
        url: '/img/brand-logo/logo-tiktok-shop-200.png',
        alt: 'tiktok-shop-logo',
    };
    return (
        <FindOrder
            logo={logo}
            title="Nhập mã đơn hàng của bạn"
            description={
                <>
                    Sau 10-30 phút kể từ khi đặt hàng, nếu đơn hàng của bạn không hiển thị
                    trên web bạn có thể sử dụng tính năng này để tìm đơn thất lạc. Nếu tìm
                    không thấy tức là đơn hàng không được ghi nhận hoàn tiền. Chi tiết
                    điều khoản xem tại đây:{' '}
                    <Link
                        className="underline text-rose-600 font-semibold hover:text-rose-800 transition-colors"
                        to="/tiktok"
                    >
                        https://longhousee.com/tiktok
                    </Link>
                </>
            }
            merchant="tiktok"
        />
    );
}

export default FIndTikTokOrder;
